import {inject, Injectable, isDevMode} from '@angular/core';
import {LoggerService} from './logger.service';


@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  // Injections
  private readonly logger: LoggerService = inject(LoggerService);

  private static readonly logID = '[AccessTokenService]';

  public getToken() {
    if (!window.localStorage) {
      return null;
    }

    const token = window.localStorage.getItem('kit.access_token');
    if (!token && isDevMode()) { this.logger.error(`${AccessTokenService.logID} -- fetch token failed`); }
    return token;

  }

  public getIdToken() {
    if (!window.localStorage) {
      return null;
    }

    const token = window.localStorage.getItem('kit.id_token');
    if (!token && isDevMode()) { this.logger.error(`${AccessTokenService.logID} -- fetch token failed`); }
    return token;

  }

}
